export default [
  {
    path: 'login',
    title: "Вход",
    free: true
  },
  {
    path: 'register',
    title: "Регистрация",
    free: true
  },
  {
    path: 'forgotpassword',
    title: "Восстановление пароля",
    free: true
  },
  {
    path: 'confirm/:uid/:code',
    title: "Подтверждение регистрации"
  },
  {
    path: 'confirm/restore/:uid/:code',
    title: "Восстановление пароля",
    card: false
  },
  {
    path: 'social/redirect/:name',
    title: "Социальные сети",
    free: true,
    props: true,
    card: false
  },
]